import React, { Component } from 'react'
import { Helmet } from 'react-helmet'
import { graphql } from 'gatsby'
import _ from 'lodash'
import Layout from '../components/layout'
import Header from '../components/header'
import Sidebar from '../components/sidebar'

const Breadcrumbs = ({ tag_type, subtag_type, parent, allMarkdownRemark, slug, videoOnly }) => {
  const children = _.filter(allMarkdownRemark.edges, e => `/${e.node.frontmatter.parent}/` === slug)
  let edge = undefined
  if (parent) {
    edge = _.find(allMarkdownRemark.edges, e => e.node.fields.key === parent)
  }
  if (!edge && !children.length && !tag_type && !subtag_type) return null
  return <div className="glossary-breadcrumbs">
    { videoOnly && <span>A video-only event, not available in the API.</span> }
    { tag_type && <span>API eventId: { tag_type }</span> }
    { subtag_type && <span>API subeventId: { subtag_type }</span> }
    { edge && <span>Subtype of: <a href={ `/${parent}/` }>{ edge.node.frontmatter.title }</a></span> }
    { children.length > 0 && <span>Subtypes: { children.map(child => <a key={ child.node.fields.slug } href={ `${child.node.fields.slug}` }>{ child.node.frontmatter.title }</a>) }</span> }
  </div>
}

const APITable = ({ ids, names }) => {
  if (!ids || !ids.length || !names || !names.length) return null
  const attributes = _.zip(ids, names)
  return <>
    <h2>API attributes</h2>
    <table className="glossary-attributes">
      <thead>
        <tr>
          <th>Attribute name</th>
          <th>attributeId</th>
        </tr>
      </thead>
      { attributes.map(attr => {
        return (
          <tr>
            <td>{ _.capitalize(attr[1]) }</td>
            <td>{ attr[0] }</td>
          </tr>
        )
      }) }
    </table>
  </>
}

export default class Event extends Component {
  state = {
    search: ''
  }

  onSearch = (search) => {
    this.setState({ search })
  }

  render() {
    const { data, pageContext } = this.props
    const { markdownRemark, allMarkdownRemark } = data // data.markdownRemark holds your post data
    const { html, frontmatter } = markdownRemark
    return (
      <Layout>
        <Helmet>
          <title>Wyscout Glossary</title>
        </Helmet>
        <Header
          allMarkdownRemark={ allMarkdownRemark }
          pageContext={ pageContext }
          searchMode={ !_.isEmpty(this.state.search) }
          search={ this.state.search }
          onSearch={ this.onSearch } />
        <main className="glossary-container">
          <Sidebar
            allMarkdownRemark={ allMarkdownRemark }
            pageContext={ pageContext }
            searchMode={ !_.isEmpty(this.state.search) }
            search={ this.state.search } />
          <section className="glossary-content">
            <article className="glossary-article">
              <h1>{ frontmatter.title }</h1>
              <Breadcrumbs { ...frontmatter } allMarkdownRemark={ allMarkdownRemark } slug={ pageContext.slug } />
              <div className="glossary-text" dangerouslySetInnerHTML={{ __html: html.replace('<h1>', '<h1 style="display: none">') }} />
            </article>
          </section>
        </main>
      </Layout>
    )
  }
}

export const query = graphql`
  query($slug: String!) {
    markdownRemark(fields: { slug: { eq: $slug } }) {
      html
      frontmatter {
        title
        parent
        tag_type
        subtag_type
        videoOnly
      }
    }
    allMarkdownRemark(filter: {
        frontmatter: {type: {eq: "event"}, title: {ne: ""}}
    }, sort: {fields: frontmatter___title}) {
        edges {
            node {
            frontmatter {
                title
                type
                parent
            }
            fields {
                slug
                key
            }
            fileAbsolutePath
            }
        }
      }
  }
`
